import { createContext } from 'react'

type ToastType = 'success' | 'error' | 'warning' | 'info'

interface Toast {
  id: string
  type: ToastType
  message: string
  duration?: number
  count: number // Track duplicate count for stacking
  onClick?: () => void
}

export interface ToastContextType {
  showToast: (
    type: ToastType,
    message: string,
    duration?: number,
    onClick?: () => void,
  ) => void
  success: (message: string, duration?: number) => void
  error: (message: string, duration?: number) => void
  warning: (message: string, duration?: number) => void
  info: (message: string, durationOrOptions?: number | ToastActionOptions) => void
}

export interface ToastActionOptions {
  duration?: number
  onClick?: () => void
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined)

export type { Toast, ToastType }
